import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@app/shared';
import { SharedSignupModule } from '@app/shared-signup/shared-signup.module';
import { CartState } from '@app/store/state/cart.state';
import {
  HeaderTitleModule, ValidationCheckModule
} from '@infomaniak/angular-common';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { HeaderInvitationB2bComponent } from './header-invitation-b2b.component';

@NgModule({
  declarations: [
    HeaderInvitationB2bComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    NgxsModule.forFeature([CartState]),
    SharedModule,
    MatButtonModule,
    SharedSignupModule,
    HeaderTitleModule,
    FormsModule,
    ReactiveFormsModule,
    ValidationCheckModule,
  ],
  exports: [HeaderInvitationB2bComponent]
})
export class HeaderInvitationB2BModule { }
